import React, { useEffect, useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './BeginScenarioUI.css'

var timeout: any = null;

var captionsEnabled = true;

var id = Tools.generateGuid();

const BeginScenarioUI = (props: UIProperties<BeginScenarioUIConfig>) => {
	const [canClick, setCanClick] = useState(true);

	props.parameters.onCanClick = () => {
		setCanClick(true);
	};

	useEffect(() => {
		timeout = setInterval(() => {
			var result = (window as any).CCEnabled;
			if(captionsEnabled !== result) {
				captionsEnabled = result;
				document.getElementById(id).style.visibility = captionsEnabled ? 'visible' : 'hidden';
			}
		}, 250);

		return () => {
			if(timeout) {
				clearInterval(timeout)
			}
			timeout = null;
		}
	}, [])
	return (
		<div className="in-game-ui-container ui-top-most-container begin-scenario-ui-container" style={{
			pointerEvents: canClick ? 'all' : 'none',
			zIndex: -1
		}} 
		onKeyUp={mapDivEnterToClick}
		>
			<img style={{
				width: '100%',
			}} className="pointer center-on-container" tabIndex={0} aria-label={/*props.parameters.text508*/ 'Start Game'} onClick={props.parameters.onClick} src={props.parameters.image}/>
			<p id={id} style={{
				fontSize: '25pt',
				position: 'absolute',
				bottom: '120px',
				left: '360px',
				margin: '0',
				width: '1270px',
			}} className="title-font">Welcome to the Charge Nurse Game! In this game, you will resolve various scenarios that you, the Charge Nurse, may face on a unit floor in real life. </p>
		</div>
	);

};

export interface BeginScenarioUIConfig extends BaseConfig {
	image: string;
	//text508: string;
	/**
	 * onCanClick is called from outside this component to signal 
	 * from the flow when the user can click on the image to being the scenario
	 */
	onCanClick: () => void;
	onClick: () => void;
}

export default BeginScenarioUI;